import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import CruiseDescriptionView from '../shared/views/cruiseDescription/cruiseDescriptionView';

const initialStateCruiseDescription = window.__INITIAL_STATE_CRUISE_DESCRIPTION__;
delete window.__INITIAL_STATE_CRUISE_DESCRIPTION__;
const cruiseDescriptionRoot = document.getElementById('cruise-description-view');

if (cruiseDescriptionRoot) {
  const { cruiseContent, labels, siteSettings, legacyMode } = initialStateCruiseDescription;
  hydrateRoot(
    cruiseDescriptionRoot,
    <Globals legacyMode={legacyMode} siteId={siteSettings?.siteId}>
      <CruiseDescriptionView
        cruiseContent={cruiseContent}
        labels={labels}
      />
    </Globals>,
  );
}
